import { AxiosResponse } from "axios";

import { CondominiumDTO } from "../models/dto/CondominiumDTO";

import { api } from "./api";

export async function getAuthStyles(
  referenceId: number,
): Promise<AxiosResponse<CondominiumDTO[]>> {
  return api.get(`/auth/styles/${referenceId}`);
}
